import React, { useEffect, useRef, useState } from 'react';
import PropTypes from 'prop-types';
import { connect, useSelector } from 'react-redux';
import isEmpty from 'lodash/isEmpty';
import isNull from 'lodash/isNull';
import { bindActionCreators } from 'redux';
import ModalBox from 'yoda-core-components/lib/components/ModalBox/ModalBox';
import classNames from 'classnames/bind';
import { dt } from 'yoda-core-components/lib/helpers/Utils/GetTailwindToken';
import LocalStorage from 'yoda-core-components/lib/helpers/LocalStorage/LocalStorage';
import withReducerSaga from '../../hoc/ReducerRegistry/withReducerSaga';
import cmSwitchWidgetReducer from '../../reducers/CMSwitchWidgetReducer';
import CMSwitchWidgetAction from '../../actions/CMSwitchWidgetAction';
import bopisMessageActions from '../../actions/BOPISMessageAction';
import { selectIRISFallBack } from '../../selectors/CMSwitchWidgetSelector';
import { selectFeatureFlags, isPreview as selectIsPreview } from '../../selectors/ContextSelector';

const cx = classNames.bind();

const CMSwitchWidget = (props) => {
    const { actions } = props;
    const isCMPage = !isEmpty(useSelector((state) => state.cmData));
    const CMFragment =
        useSelector((state) => selectFeatureFlags(state))?.enableCMFragments || false;
    const [values, setValues] = useState('Select a CMS to view');
    const [showModal, setIsModal] = useState(false);
    const [cmDisable, setCmDisable] = useState(false);
    const isIRISPreSelectRef = useRef('');
    const regex = /p\/[A-Za-z0-9]+/;
    const windowObj = !__SERVER__ && window.location.pathname;
    const isPDP = regex.test(windowObj);
    const irisEvergreenload = LocalStorage.getData('irisEvergreenload', true);
    const cmEvergreenload = LocalStorage.getData('cmEvergreenload', true);
    const isIRISFallBack = useSelector((state) => selectIRISFallBack(state));
    const isPreview = useSelector((state) => selectIsPreview(state));

    useEffect(() => {
        if (isIRISFallBack) {
            setIsModal(true);
            setValues('IRIS');
        }
    }, [isIRISFallBack, values]);

    useEffect(() => {
        setValues(isCMPage ? 'core Media' : 'IRIS');
    }, [isCMPage]);

    useEffect(() => {
        if (window.location.pathname === '/m/evergreen') {
            setCmDisable(true);
            setValues(irisEvergreenload ? 'IRIS' : cmEvergreenload ? 'core Media' : '');
        }
    }, []);

    !isNull(LocalStorage.removeData('irisEvergreenload', true));
    !isNull(LocalStorage.removeData('cmEvergreenload', true));
    useEffect(() => {
        if (isPDP) {
            setValues(CMFragment ? 'core Media' : 'IRIS');
        }
    }, [CMFragment]);

    const handleChange = (event) => {
        setValues(event.target.value);
        const regexDept = /d\/[A-Za-z0-9]+/;
        const isErrorPage = document.getElementById('error-page');
        if (
            event.target.value === 'core Media' &&
            regexDept.test(windowObj) &&
            isErrorPage &&
            isPreview
        ) {
            /**
             * This condition is for specific scenario on cmwidget change
             * If CM page is enabled and IRIS don't have content or expired
             * reload the page to render CM data
             * */
            /* istanbul ignore next */
            window.location.reload();
        }
        /* istanbul ignore else */
        if (event.target.value !== '') {
            actions.getSiteWideWidgetSelection(event.target.value);
            actions.resetBOPISMessage();
        }
    };

    const handleClose = () => {
        setIsModal(false);
    };

    return (
        <div>
            <label className={dt(['smOnly:text-sm', 'whitespace-nowrap'])}>
                You're currently viewing:
                <select
                    value={values}
                    onChange={handleChange}
                    ref={isIRISPreSelectRef}
                    className={dt(['smOnly:w-20'])}
                >
                    <option value="Select a CMS to view" selected disabled>
                        Select a CMS to view
                    </option>
                    <option id="IRIS" value="IRIS">
                        IRIS
                    </option>
                    <option id="coreMedia" value="core Media" disabled={cmDisable}>
                        Core Media
                    </option>
                </select>
            </label>
            {showModal && (
                <ModalBox
                    showModal={showModal}
                    onClose={handleClose}
                    defaultHeader
                    modalTitleTheme={`${cx('modalTitle')} ${dt([
                        'mb-2',
                        'text-left',
                        'text-black',
                        'text-2xlarge',
                    ])}`}
                    automationId="test-automation-modal"
                    iconAutomationId="icon-automation-id"
                    title="You're now on IRIS"
                    titleAutomationId="title-automation-id"
                    subTitle=""
                    subTitleAutomationId="subtitle-automation-id"
                >
                    Since the page you have selected does not exist in coreMedia, we switched to
                    IRIS.
                </ModalBox>
            )}
        </div>
    );
};

CMSwitchWidget.propTypes = {
    isIRISFallBack: PropTypes.bool,
};

CMSwitchWidget.defaultProps = {
    isIRISFallBack: true,
};

const mapDispatchToProps = (dispatch) => ({
    actions: bindActionCreators({ ...CMSwitchWidgetAction, ...bopisMessageActions }, dispatch),
});

export default withReducerSaga([cmSwitchWidgetReducer])(
    connect(null, mapDispatchToProps)(CMSwitchWidget)
);
